export default "__VITE_ASSET__B$ZnZ9JP__"